module.exports = __webpack_public_path__ + "static/media/group.f7db37ff.svg";